import React, { useContext, useState, useEffect } from 'react'
import { Row, Col, Container, InputGroup, Image, FormControl, Form, Button, ButtonGroup, Card, Alert, Spinner } from "react-bootstrap"
import { Link, Redirect } from 'react-router-dom';
import { makeStyles } from '@material-ui/core'
import { Paper, TextField, Grid } from '@material-ui/core';
import { Close } from '@material-ui/icons';
import axios from "axios"
import 'bootstrap/dist/css/bootstrap.min.css';
import { UserContext } from "./Context/UserContext";
import { ToastContainer, toast } from "react-toastify"
import { Modal, ModalHeader, ModalBody, ModalFooter, Input } from 'reactstrap';
import Timer from "./Timer"
import { LoaderC } from "./LoaderC"
import Loader from "react-loader-spinner";
import Switch from '@material-ui/core/Switch';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { Otp } from 'react-otp-timer';
//import FormControl from '@material-ui/core/FormControl';
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import 'react-toastify/dist/ReactToastify.css';
import "./login.css"
import "./common.css"
import CustomerDashboard from './CustomerDashboard';
import GetUserAddress from './ReadyToShop'
import OtpInput from 'react-otp-input';
import InputAdornment from '@material-ui/core/InputAdornment';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import IconButton from '@material-ui/core/IconButton'
import { base_url } from '../globalConstants';
import Cookies from 'universal-cookie';

import universalLanguageDetect from '@unly/universal-language-detector';


import { FALLBACK_LANG, SUPPORTED_LANGUAGES } from '../utils/i18constants';


const mystyle = {
  color: "white",
  backgroundColor: "#FF7F50",
  fontFamily: "Arial",
  borderRadius: "12px"
};

const useStyles = makeStyles((theme) => ({
  root: {
    '& > *': {
      // margin: theme.spacing(1),
      margin: '5px',
      width: '25ch',
    },
  },
  paper: {
    // padding: theme.spacing(2),
    padding: '25px 40px 25px 40px',
    textAlign: 'center',
    color: theme.palette.text.secondary,
  },
  spaceBetweenFields: {
    // marginTop: '10px',
    marginBottom: '10px'
  }
}));



export default function Login(props) {

  //New Code variables
  const cookies = new Cookies();
  const classes = useStyles();
  const [errorText1, setErrorText1] = useState(' ');
  const [show, setShow] = useState(false);
  const [errorIncorrectDetail, setErrorIncorrectDetail] = useState("");
  const [errorIncorrectOtp, setErrorIncorrectOtp] = useState("");

  // const handleClose = () => setShow(false);
  const handleShowAddressModal = () => setShow(true);

  const lang = universalLanguageDetect({
    supportedLanguages: SUPPORTED_LANGUAGES, // Whitelist of supported languages, will be used to filter out languages that aren't supported
    fallbackLanguage: FALLBACK_LANG, // Fallback language in case the user's language cannot be resolved
   
    errorHandler: (error, level, origin, context) => { // Optional - Use you own logger here, Sentry, etc.
      console.log('Custom error handler:');
      console.error(error);

      
    },
  });


  console.log('language', lang)
  cookies.set('language', lang);
  
  //--New Code variables
  console.log( 'languahe--get',cookies.get('language'))

  
  //--New Code variables
  
  // NEW MODAL
  const [open, setOpen] = useState(false);
  const [open2, setOpen2] = useState(false);
  
  // const [focusAfterClose, setFocusAfterClose] = useState(true);
  
  const toggle = () => setOpen(!open);
  const toggle2 = () => setOpen2(!open2);

  
  //toggle

  const [Toggler, setToggler] = useState(true);
  //NEW MODAL

  //login way decision variable
  
  const [LoggingVia, setLoggingVia] = useState('Number')

  const context = useContext(UserContext);
  const [Email, setEmail] = useState('');
  const [EmailviaOtp, setEmailviaOtp] = useState('');
  const [Password, setPassword] = useState('');
  const [Logged, setLogged] = useState(false);
  const [Id, setId] = useState('');
  const [Countries, setCountries] = useState([]);
  const [TeleCode, setTeleCode] = useState('')
  const [CountrySelected, setCountrySelected] = useState('')
  const [TeleCodeisSelected, setTeleCodeisSelected] = useState(false);
  const [TeleLength, setTeleLength] = useState('')
  const [Phone, setPhone] = useState('')
  const [msg, setmsg] = useState()
  const [OTP, setOTP] = useState('')
  const [Loading, setLoading] = useState(false);
  const [SendOTPLoading, setSendOTPLoading] = useState(false);
  const [OTPsentLoading, setOTPsentLoading] = useState(false);
  const [CurrentToggleState, setCurrentToggleState] = useState('botón de acceso via email');
  const [HoverState, setHoverState] = useState(false);
  var [Minutes, setMinutes] = useState(1);
  var [Seconds, setSeconds] = useState(59);
  const [passwordVisibilityDetails,setPasswordVisibilityDetails] = useState({icon:false,property:false})
  
  const handleVisibility = () =>{
    setPasswordVisibilityDetails({icon:!passwordVisibilityDetails.icon,property:!passwordVisibilityDetails.property})
   };

  const handlePassChange = (event) => {

    setPassword(event.target.value);
    setErrorText1('')
  }

  const handleEmailChange = (event) => {
    setEmail(event.target.value);
    // console.log(event.target.value);
    setErrorText1('')
  }

  const handleEmailviaOtpChange = (event) => {
    setErrorIncorrectDetail('')
    setEmailviaOtp(event.target.value);
  }
  
  const handleTogglerChange = () => {
    setErrorIncorrectDetail('')
    setToggler(!Toggler);
    console.log(`value is now ${Toggler}`);
    if (Toggler) {
      setCurrentToggleState('botón de acceso via numero telefónico')
      setLoggingVia('Email')

    } else {
      setCurrentToggleState('botón de acceso via email');
      setLoggingVia('Number')
      console.log(LoggingVia);
    }
  }

  const handleSubmit = async e => {

    e.preventDefault();
    
    const Formdata = new FormData();
    Formdata.append('email', Email);
    Formdata.append('password', Password);

    console.log(Formdata);

    await axios({
      method: 'post',
      url: base_url+'obtain_token/',
      data: Formdata,
      headers: { 'Content-Type': 'multipart/form-data' }
    })
    .then(function (response) {
        //handle success

        // console.log(response.data)
        
        // console.log('USERTYPE',response.data.user.Type)

        if(response.data.user.Type === 'Customer'){
          localStorage.setItem('logged', 'true');
          // console.log(response);
          // console.log('success');
          // console.log(response.data.user.Id)
          localStorage.setItem("ezzyid", response.data.user.Id)
          setId(response.data.user.Id);
          localStorage.setItem('username', response.data.user.Name);
          localStorage.setItem("validated", response.data.email_validated);
          localStorage.setItem('token', response.data.token);
          setLoading(true);
          //setLogged(true);
		  setOpen(true);
        }
        else
          setErrorText1('Invalid Credentials')        
        
        // setShow(true)
        // const handleShowAddressModal = () => setShow(true);


      })
      .catch(function (response) {
        //handle error
        console.log(response);
        console.log('error')

        setErrorText1('Invalid Credentials')
        // document.getElementsByTagName('TextField').setAttribute("class", "errorTextField"); 
        // toast.warn('Invalid UserName or Password')
      });
  }


  const fetchcountries = async e => {
    const { data } = await axios.get(base_url + 'country_state_details/')
    console.log(data)
    setCountries(data);

  }

  useEffect(() => {
    fetchcountries();
    localStorage.setItem('logged', 'false');
  }, [])

  const handleCountryChange = (event) => {
    setCountrySelected(event.target.value);
    Countries.map(key => {
      if (key.name === event.target.value) {
        setTeleCode(key.telecode);
        setTeleLength(key.tele_length);
        console.log(TeleCode);
        setTeleCodeisSelected(true);

      }
    })
  }

  const handleChangePhoneNumber = (event) => {
    setErrorIncorrectDetail('')
    setPhone(event.target.value);

    { /* if (Phone.length >= TeleLength) {
      setmsg(true);
    } else {
      setmsg(false);
    } */ }

    console.log(Phone);
  }

  const handleSendOtpSubmit = (event) => {
    event.preventDefault();

    console.log(LoggingVia);
    console.log(Phone)
    const otpData = new FormData();

    if (LoggingVia === 'Email') {
      otpData.append('MobileNumber', EmailviaOtp)
      console.log('Email set')
    } else if (LoggingVia === 'Number') {
      otpData.append('MobileNumber', Phone);
      console.log('number set')
    }


    otpData.append('type', "login")

    console.log(Phone);
    axios(
      {
        method: 'post',
        url: base_url+'verify_number/',
        data: otpData,
        headers: { 'Content-Type': 'application/json' }
      }
    )
      .then(function (response) {
        console.log(response);
        console.log('OTP sent');

        setSendOTPLoading(true);
        setTimeout(() => {
          // toggleNested();
          toggle2();
          setOTPsentLoading(true);



        }, 3000);

      })
      .catch(function (response) {
        console.log(response);
        console.log('OTP sending failure');
        // toast.warn('Phone number doesnt exists! Please enter again');
        setErrorIncorrectDetail('detalle incorrecto. vuelva a intentar')
      })
  }

  const handleOTPChange = (event) => {
    
    setErrorIncorrectOtp('')
    setOTP(event);
	//pk start
    //console.log('OTP verification Done SUccessfullypkkk');
    var Carrier;
	if (event.length >= 4) {
		if (LoggingVia === 'Email') {
		  Carrier = EmailviaOtp;
		} else if (LoggingVia === 'Number') {
		  Carrier = Phone;
		}

		axios.get(base_url+`verify_number/?MobileNumber=${Carrier}&otp=${event}&type=login`)
		  .then(function (response) {

			console.log('OTP verification Done SUccessfully');
			console.log(response);

			localStorage.setItem('logged', 'true');
			localStorage.setItem('username', response.data.user_details.user.Name);
			console.log(response.data.user_details.user.Name)
			localStorage.setItem("validated", response.data.user_details.user.email_validated);
			// console.log(response.data.email_validated)
			localStorage.setItem('token', response.data.user_details.token);
			localStorage.setItem("ezzyid", response.data.user_details.user.Id)
			console.log(response.data.user_details.user.Id)




			console.log(response.data.user_details.user.Name);
			setLoading(true);

			setTimeout(() => {
			  // toggleAll();
			  //localStorage.setItem('logged', true);
			  setLogged(true);
			}, 3000);
			// console.log(localStorage.getItem('logged'))



		  })
		  .catch(function (response) {
			console.log(response.status);
			console.log('OTP verification failure');
			// toast.warn('Please try again');
			setErrorIncorrectOtp('Incorrect Code. Try again.')

		  })
	} //pk end
	
  }

  const handleOTPverify = async e => {
    e.preventDefault();

    var Carrier;

    if (LoggingVia === 'Email') {
      Carrier = EmailviaOtp;
    } else if (LoggingVia === 'Number') {
      Carrier = Phone;
    }

    axios.get(base_url+`verify_number/?MobileNumber=${Carrier}&otp=${OTP}&type=login`)
      .then(function (response) {

        console.log('OTP verification Done SUccessfully');
        console.log(response);

        localStorage.setItem('logged', 'true');
        localStorage.setItem('username', response.data.user_details.user.Name);
        console.log(response.data.user_details.user.Name)
        localStorage.setItem("validated", response.data.user_details.user.email_validated);
        // console.log(response.data.email_validated)
        localStorage.setItem('token', response.data.user_details.token);
        localStorage.setItem("ezzyid", response.data.user_details.user.Id)
        console.log(response.data.user_details.user.Id)




        console.log(response.data.user_details.user.Name);
        setLoading(true);

        setTimeout(() => {
          // toggleAll();
          //localStorage.setItem('logged', true);
          setLogged(true);
        }, 3000);
        // console.log(localStorage.getItem('logged'))



      })
      .catch(function (response) {
        console.log(response.status);
        console.log('OTP verification failure');
        // toast.warn('Please try again');
        setErrorIncorrectOtp('código incorrecto. vuelva a intentar')

      })

  }


  let style = {
    otpTimer: {
      margin: '10px',
      color: 'blue',
    },
    resendBtn: {
      // backgroundColor: '#5cb85c',
      // border: '1 px solid #ccc'
      // color: 'white',
      color: '#ff5500',
      border: '1px solid #ff5500',
      backgroundColor: 'white',
      borderRadius: '5px',
      padding: '5px 15px',

      "&:hover":{
        color: 'white',
        backgroundColor: '#ff5500',
      },
      "&:focus":{
        outline: '5px solid #ff5500'
      }
    }
  }

  const resendEvent = async () => {


    const ResendotpData = new FormData();

    if (LoggingVia === 'Email') {
      ResendotpData.append('MobileNumber', Email)
      console.log('Email set')
    } else if (LoggingVia === 'Number') {
      ResendotpData.append('MobileNumber', Phone);
      console.log('number set')
    }


    ResendotpData.append('type', "login")

    axios(
      {
        method: 'post',
        url: base_url+'verify_number/',
        data: ResendotpData,
        headers: { 'Content-Type': 'application/json' }
      }
    )
      .then(function (response) {
        console.log(response);
        console.log('OTP sent');

        console.log('resend done')
      })
      .catch(function (response) {
        console.log(response);
        console.log('OTP sending failure');
        console.log('resend failure')

      })
  }

  // var textstyle={
  //   color: "#B83227", 

  //   if(HoverState){
  //     color: "red",
  //   }, 

  //   fontWeight: 'bold', 
  //   textDecorationLine: 'underline', 
  //   textAlign: 'center'
  // }

  // function handleHover(){
  //   setHoverState(!HoverState); 
  // }







  return (
    <div>

      <UserContext.Provider value={context}>
        {cookies.get('language') ==='es' ?
          <Redirect
            to={{
              pathname: '/login_es',
               state: { Logged: Logged }
            }}
          />

          :      ''}
      </UserContext.Provider>
      <UserContext.Provider value={context}>
        {Logged ?
          <Redirect
            to={{
              pathname: '/customerdashboard',
              state: { Logged: Logged }
            }}
          />

          : ''}
      </UserContext.Provider>



      <Container>

      <Row className="">
        <Col style={{textAlign: "center", marginTop: '10px'}} >
          {/* <h1 ><p id="logo-container" className="brand-logo text-center compamny_title indigo-text ">Ezzy<span className="orange-text">Ship</span></p></h1> */}

          <a href="https://www.ezzyship.com/es.html" title="Login"><Image src="assets/images/group-4-copy.png" /></a>

        </Col>

      </Row><br/>
        <Row>

          <Col md={{ span: 4, offset: 4 }}>

            <Paper className="justify-content-md-center" className={classes.paper} elevation={5} alignContent="center"  >
              <h3 className='mainHeading'>Bienvenido de nuevo</h3>
              <p className='secondaryHeading' >
              Iniciar sesión abajo para acceder al tablero de EZZYSHIP.<br/>
                <span className='errorText'>{errorText1}</span>
              </p>

              <Form onSubmit={handleSubmit} noValidate >

                    <Row >
                      <Col className="justify-content-md-center"  >
                        <TextField id="email_id" label="Correo Electrónico" variant="filled" className='textField' fullWidth
                          value={Email} onChange={handleEmailChange} type="email" />
                      </Col>
                    </Row><br/>
                    <Row>
                      <Col className="justify-content-md-center" >
                        <TextField id="password" label="Contraseña" variant="filled" className='textField' fullWidth
                          value={Password}  type={passwordVisibilityDetails.property?"text":"password"} InputProps={{
                            endAdornment: (
                              <InputAdornment position='end'>
                                <IconButton
                                  aria-label='toggle password visibility'
                                  onClick={handleVisibility}
                                  >
                                  {passwordVisibilityDetails.icon?<Visibility/>:<VisibilityOff/>}
                                </IconButton>
                              </InputAdornment>
                            ),
                          }} onChange={handlePassChange} />
                      </Col>
                    </Row>
                    <Row>
                      <Col className="justify-content-md-center" >
                        <Button variant="Link" id="linkLoginVia" className=" loginlink " onClick={toggle} >
                        acceso via email/ numero telefonico.
                        </Button>
                      </Col>
                    </Row>
                    <Row>
                      <Col className="justify-content-md-center" >
                        <Button id="login" className="customButton1" type="submit" size='lg' block >
                        Iniciar Sesion
                        </Button>
                        <p className='secondaryHeading' style={{ marginTop: '10px', marginBottom: 0 }}>No tiene una cuenta ?</p>
                        <Link to="signup_es" className="customButton2" >
                          <Button id="signup" className="customButton2" variant="outline-primary" size='lg' block  >
                          Crear una cuenta
                          </Button>
                        </Link>
                      </Col>
                    </Row>

                    {/* MODAL ONE */}
                    <Modal isOpen={open}>
                    <div style={{textAlign: 'right', marginTop: '7px', marginRight: '7px'}}>
    <Close onClick={toggle} style={{cursor: 'pointer'}} className='' justify='flex-end' />
  </div>
                      <ModalBody style={{ textAlign: 'center' }}>
                        { /* <div className="required-field">
            <Form.Group controlId="validationCustom01">
            <Form.Control style={{ borderRadius: "12px" }} defaultValue="choose country" onChange={handleCountryChange} label="country" required as="select" size="lg">

              <option disabled>choose country</option>

              {Countries.map(key => {
                return (
                  <option value={key.name}>{key.name}</option>
                )
              })}
            </Form.Control>
            <Form.Control.Feedback>Looks good!</Form.Control.Feedback>
            <Form.Control.Feedback type="invalid">
              Please Choose a Country.
            </Form.Control.Feedback>
            </Form.Group>
            </div> */ }


                    <FormControlLabel
                      value="end"
                      control={<Switch color="primary"/>}
                      label={CurrentToggleState}
                      labelPlacement="end"
                      onChange={handleTogglerChange}
                    />

                    {Toggler ? <div> <h4 style={{ color: '#008899', textAlign: 'center' }} >INGRESE NÚMERO DE MÓVIL WHATSAPP REGISTRADO SIN CÓDIGO DE PAÍS</h4><br />
                      <Row>


                        <Col style={{ textAlign: 'center' }} xs={12} md lg={12}>
                          {/* <InputGroup>
                            <Input onChange={handleChangePhoneNumber} type="number" placeholder="Phone Number" />
                          </InputGroup> */}

                          <TextField id="enterPhoneNumber" label="Numero de teléfono" variant="filled" className='textField' 
                            onChange={handleChangePhoneNumber}
                            
                            helperText="ingresa no. sin código de país " />
                          {/* {
                            errorIncorrectDetail == ""
                              ? ""
                              : <p className="errorText" style={{marginBottom:'0'}}>{errorIncorrectDetail}</p>
                          } */}
                        </Col>
                      </Row>
                    </div>


                      : <div> <h5 style={{ color: '#008899', fontSize:'1.5rem' }}>ingresa email ID registrado:</h5> <br />

                        <Row>
                          <Col style={{ textAlign: 'center' }} xs={12} md lg={12}>
                            {/* <InputGroup type="text">
                              <Input type="email" onChange={handleEmailviaOtpChange} placeholder="Enter your email" />
                            </InputGroup> */}

                            <TextField id="enterEmailId" label="Correo Electrónico"  variant="filled" className='textField' 
                              onChange={handleEmailviaOtpChange} 
                              helperText="Correo electrónico registrado" />  
                          </Col>
                        </Row></div>

                    }
                    <br />                    
                    {
                      Phone.length >= 7 || EmailviaOtp.length ? SendOTPLoading ? OTPsentLoading 
                      ? <Button id="sendingOtp" className="customButton2" disabled>

contraseña de un solo uso enviado!!
                    </Button> : <Button id="sendingOtp" className="customButton2" disabled>
                        <Spinner
                          as="span"
                          animation="grow"
                          size="sm"
                          role="status"
                          aria-hidden="true"
                        />
              enviando contraseña de un solo uso.....
              </Button> 
              
              : 
                // <Button color="success" onClick={handleSendOtpSubmit}>Send Otp</Button> 
                    <Button style={{ textAlign: 'center' }} id="sendOtpBtn" className="customButton2" onClick={handleSendOtpSubmit}  >
                      envía contraseña de un solo 
                    </Button>
              : ''
              
              }
              {
                              errorIncorrectDetail == ""
                                ? ""
                                : <p className="errorText" style={{marginBottom:'0', marginTop:"11px", fontSize:"13px"}}>{errorIncorrectDetail}</p>
                            }    

                   

                  </ModalBody>

                  
                  {/* <ModalFooter> */}
                    {/* <Button id="closeOtpModal1" className="customButton1" onClick={toggle} > */}
                      {/* CLOSE */}
                    {/* </Button> */}
                    {/* <Button color="primary" onClick={toggle}>Close</Button> */}
                  {/* </ModalFooter> */}
                </Modal>


                {/* MODAL TWO */}
                <Modal style={{ height: '80%' }} isOpen={open2} >
                  <ModalHeader>INGRESE EL CÓDIGO DE 4 DÍGITOS RECIBIDO EN SU NÚMERO DE MÓVIL DE WHATSAPP / ID DE CORREO ELECTRÓNICO</ModalHeader>
                  {/* <ModalHeader>Enter 4 Digit Code sent on your WhatsApp : {TeleCode + Phone}</ModalHeader> */}
                  <ModalBody>
                    <Row>
                      <Col xs={6} md lg={6}>
                        {/* <InputGroup>
                          <Input value={OTP} onChange={handleOTPChange} placeholder="Enter OTP here" defaultValue="ex:1122" />
                        </InputGroup> */}
                        <OtpInput
                           
                            inputStyle={style={"outline":"none","border":"none",'width':"50px","height":"50px","border-bottom":"3px solid black","font-size":"20px"}}
                            // className='otp_styling'
                            value={OTP}
                            onChange={(event)=>{handleOTPChange(event)}}
                            numInputs={4}
                            separator={<span>-</span>}
                          />

                        {/* <TextField id="enterOtp" label="Enter code here" variant="filled" className='textField' fullWidth
                          value={OTP} onChange={handleOTPChange}/> */}

                          {
                            errorIncorrectOtp == ""
                            ?""
                            :<p className="errorText" style={{marginBottom:'0'}}>{errorIncorrectOtp}</p>
                          }

                      </Col>
                      <Col xs={6} md lg={5} style={{ textAlign: 'center' }}>
                        <Otp
                          style={style}
                          minutes={1.99}      // Minutes ( Pass the no of minutes that you want count )
                          resendEvent={resendEvent} //  Resend button event you can pass your function name here
                        />
                      </Col>
                    </Row>

                    {OTP.length === 4 ? Loading ? <Button className="customButton1" disabled>
                      <Spinner
                        as="span"
                        animation="grow"
                        size="sm"
                        role="status"
                        aria-hidden="true"
                      />
                      Logging in....
                      </Button> : <Button className="customButton2" onClick={handleOTPverify}>acceso</Button> : ''}


                  </ModalBody>

                  
                  <ModalFooter style={{ height: '100%' }}>
                    <Button id="closeOtpModal2" className="customButton1" onClick={toggle2}  >
                      carrer
                    </Button>
                    {/* <Button color="primary" onClick={toggle2}>Close</Button> */}
                  </ModalFooter>
                </Modal>

              </Form>
            </Paper>

          </Col>

        </Row>


      {/* <GetUserAddress showAddressModal = {true} />   */}
      {/* <GetUserAddress showAddressModal = {show} />   */}
      {/* <Button onClick={()=>handleShowAddressModal()}>Open Modal</Button>                            */}

      


      </Container>

      <Timer />


    </div>

  )
}
